<div class="d-flex flex-column justify-content-center align-items-center p-5 text-center">
    <div class="loader-scene pt-1">
        <span class="loader">
            <i class="fa-solid fa-bug fa-rotate-90"></i>
        </span>
    </div>
    <div>
        Es ist ein Fehler aufgetreten...
    </div>
    <div class="mt-3">
        <a class="btn btn-primary" [href]="'/'">
            Seite neu laden
            <i class="fa-solid fa-arrows-rotate"></i>
        </a>
    </div>
</div>